import { BaseNotification } from '../helpers/types';
import { INotificationService } from './INotificationService';
import { logger } from '@common/logging/logger';

export class NotificationServiceExceptionDecorator implements INotificationService {
  private decoree: INotificationService;

  constructor(decoree: INotificationService) {
    this.decoree = decoree;
  }

  addNotification(notification: BaseNotification): void {
    try {
      this.decoree.addNotification(notification);
    } catch (err) {
      this.logError('addNotification', err);
    }
  }

  setPanelState(open: boolean): void {
    try {
      this.decoree.setPanelState(open);
    } catch (err) {
      this.logError('setPanelState', err);
    }
  }

  // private utility methods

  private logError(methodName: string, error: unknown): void {
    logger.error(`NotificationService.${methodName} failed:`, error);
  }
}
